import {isLoggedInByCookie} from '@/services/sso'

const state = {
  loggedIn: isLoggedInByCookie(),
};

// getters
const getters = {
  LoggedIn: state => state.loggedIn,
};

// actions
const actions = {
  setLoggedIn({commit}, data) {
    commit('setLoggedIn', data);
  },
};

// mutations
const mutations = {
  setLoggedIn(state, data) {
    state.loggedIn = data; // Korrektur: Ändere "this.loggedIn" zu "state.loggedIn"
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
